<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="114px"
    >
      <el-form-item label="公司名称" prop="statisticsCompanyName">
          <el-input
          v-model="queryParams.statisticsCompanyName"
          placeholder="请输入公司名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="机器人ID" prop="robotId">
        <el-input
          v-model="queryParams.robotId"
          placeholder="请输入机器人ID"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="被统计部门" prop="statisticsDeptName">
          <el-input
          v-model="queryParams.statisticsDeptName"
          placeholder="请输入被统计部门名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="接收人" prop="receiverNames">
        <el-input
          v-model="queryParams.receiverNames"
          placeholder="请输入接收人名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          v-model="queryParams.status"
          placeholder="请选择状态"
          clearable
        >
          <el-option label="启用" :value="1" />
          <el-option label="禁用" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 工具栏 -->
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          >新增</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          >删除</el-button
        >
      </el-col>
      <right-toolbar
        :showSearch.sync="showSearch"
        @queryTable="getList"
      ></right-toolbar>
    </el-row>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="statisticsList"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column
        label="配置ID"
        align="center"
        prop="id"
        show-overflow-tooltip
      />
      <el-table-column
        label="机器人ID"
        align="center"
        prop="robotId"
        show-overflow-tooltip
      />
      <el-table-column
        label="被统计部门"
        align="center"
        prop="statisticsDeptName"
        show-overflow-tooltip
      />
      <el-table-column
        label="分组"
        align="center"
        prop="excludeApprovalGroupName"
        show-overflow-tooltip
      />
      <el-table-column
        label="模板"
        align="center"
        prop="excludeApprovalTemplateName"
        show-overflow-tooltip
      />
      <el-table-column
        label="接收人"
        align="center"
        prop="receiverNames"
        show-overflow-tooltip
      />
      <el-table-column label="状态" align="center" prop="status">
        <template slot-scope="{ row }">
          <el-tag v-if="row.status === 1" type="success">启用</el-tag>
          <el-tag v-else-if="row.status === 2" type="danger">禁用</el-tag>
          <span v-else>{{ row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="创建时间"
        align="center"
        prop="createTime"
        show-overflow-tooltip
      />
      <el-table-column
        label="更新时间"
        align="center"
        prop="updateTime"
        show-overflow-tooltip
      />
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
        width="260"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-view"
            @click="handleDetail(scope.row)"
            >详情</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-date"
            @click="handleManageDates(scope.row)"
            >配置日期</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 新增/修改弹窗（抽屉） -->
    <el-drawer
      :title="title"
      :visible.sync="open"
      size="40%"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        style="padding: 0 20px"
      >
        <el-form-item label="机器人ID" prop="robotId">
          <el-input
            v-model="form.robotId"
            placeholder="请输入机器人ID"
            :disabled="true"
          />
        </el-form-item>
        
        <!-- 被统计部门（原有功能，保持不变） -->
        <el-form-item label="被统计部门" prop="statisticsDeptId">
          <el-input
            v-model="form.statisticsDeptName"
            placeholder="请选择被统计部门"
            :disabled="isDetail"
            readonly
            @focus="openDeptTree"
          >
            <el-button
              slot="append"
              icon="el-icon-arrow-down"
              @click="openDeptTree"
              :disabled="isDetail"
            />
          </el-input>
        </el-form-item>

        <!-- 新增：分组选择 -->
        <el-form-item label="分组" prop="excludeApprovalGroupId">
          <el-select
            style="width: 100%"
            filterable
            clearable
            v-model="form.excludeApprovalGroupId"
            placeholder="请选择分组"
            @change="handleGroupChange"
            :disabled="isDetail"
          >
            <el-option 
              v-for="item in groupOptions" 
              :key="item.id" 
              :label="item.name" 
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <!-- 新增：模板选择 -->
        <el-form-item label="模板" prop="excludeApprovalTemplate">
          <el-select
            style="width: 100%"
            filterable
            clearable
            v-model="form.excludeApprovalTemplate"
            placeholder="请选择模板"
            :disabled="isDetail || !form.excludeApprovalGroupId"
          >
            <el-option 
              v-for="item in templateOptions" 
              :key="item.tptId" 
              :label="item.name" 
              :value="item.tptId"
            />
          </el-select>
          <div style="font-size: 12px; color: #999; margin-top: 4px">
            请先选择分组
          </div>
        </el-form-item>

        <el-form-item label="接收人名称" prop="receiverNames">
          <el-input
            v-model="form.receiverNames"
            placeholder="请输入接收人名称，多个用英文逗号分隔"
            :disabled="isDetail"
          />
          <span style="font-size: 12px; color: #999"
            >多个接收人用英文逗号(,)分隔</span
          >
        </el-form-item>
        
        <!-- 新增时隐藏状态，编辑时显示 -->
        <el-form-item label="状态" prop="status" v-if="isEditMode">
          <el-radio-group v-model="form.status" :disabled="isDetail">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="创建时间" v-if="form.createTime">
          <span>{{ form.createTime }}</span>
        </el-form-item>
        <el-form-item label="更新时间" v-if="form.updateTime">
          <span>{{ form.updateTime }}</span>
        </el-form-item>
        
        <!-- 新增时显示日期选择，编辑时不显示 -->
        <el-form-item label="统计日期" prop="statisticsDates" v-if="!isEditMode">
          <el-date-picker
            v-model="form.statisticsDates"
            type="dates"
            placeholder="请选择需要统计的日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            :picker-options="formDatePickerOptions"
          />
          <div style="font-size: 12px; color: #999; margin-top: 4px">
            可选择多个日期，选中的日期将作为考勤统计的基准日（只能选择今天及之后的日期）
          </div>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer" style="text-align: center; padding: 20px 0">
        <el-button type="primary" @click="submitForm" v-if="!isDetail"
          >确 定</el-button
        >
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-drawer>

    <!-- 配置日期弹窗 -->
    <el-drawer
      title="配置统计日期"
      :visible.sync="dateDialogVisible"
      append-to-body
    >
      <el-form label-width="100px">
        <el-form-item label="被统计部门">
          <span>{{ currentDeptName }}</span>
        </el-form-item>
        <el-form-item label="新增日期">
          <el-date-picker
            v-model="newDates"
            type="dates"
            placeholder="请选择需要新增的日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            :picker-options="datePickerOptions"
          />
          <div style="font-size: 12px; color: #999; margin-top: 4px">
            只能选择今天及之后的日期，已配置的日期不可选
          </div>
        </el-form-item>
        <el-form-item label="已配置日期">
          <div v-if="dateList.length > 0">
            <el-tag
              v-for="(date, index) in dateList"
              :key="index"
              closable
              @close="handleDeleteDate(date)"
              style="margin: 4px 8px"
            >
              {{ formatDate(date) }}
            </el-tag>
          </div>
          <span v-else style="color: #999">暂无配置日期</span>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dateDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="submitDates" :loading="dateSubmitting"
          >保 存</el-button
        >
      </div>
    </el-drawer>

    <!-- 部门选择树组件 (zhDepatrTree) - 保持不变 -->
    <zhDepatrTree
      @update="closeDeptTree"
      @getdepartSelectList="getDeptSelectList($event)"
      :departopen="deptTreeVisible"
      :selectdepartList="selectDeptList"
      v-if="deptTreeVisible"
      :companyId="companyId"
      :url="deptTreeUrl"
    />
  </div>
</template>

<script>
import {
  listClockInStatistics,
  getClockInStatistics,
  addClockInStatistics,
  updateClockInStatistics,
  delClockInStatistics,
  clockInStatisticsDateBatch,
  clockInStatisticsDatelist,
  clockInStatisticsDatedelete,
} from "@/api/attendanceStatistics";
import zhDepatrTree from "./zhDepatrTree.vue";
import { GetGlobalTptGroupoPage, GetTptList } from "@/api/Industry";

export default {
  name: "AttendanceStatistics",
  components: {
    zhDepatrTree,
  },
  data() {
    return {
      // 默认机器人ID
      defaultRobotId: "wtoi0xt5kr43guqhxd6ah7zcmdq745c9",
      // 公司ID（从路由获取）
      companyId: this.$route.query.EId || "",
      // 部门树接口地址
      deptTreeUrl: this.$route.query.url || "",
      // 部门树相关
      deptTreeVisible: false,
      selectDeptList: [],
      // 分组选项
      groupOptions: [],
      // 模板选项
      templateOptions: [],
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 表格数据
      statisticsList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否详情模式
      isDetail: false,
      // 是否编辑模式（用于控制状态显示）
      isEditMode: false,
      // 日期弹窗
      dateDialogVisible: false,
      dateSubmitting: false,
      currentConfigId: null,
      currentDeptName: "",
      dateList: [],
      newDates: [],
      // 已配置的日期列表（用于禁用）
      disabledDates: [],
      // 日期选择器配置 - 动态禁用已配置的日期
      datePickerOptions: {
        disabledDate: (time) => {
          // 获取今天的日期（不含时间部分）
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          
          // 1. 禁用今天之前的日期
          if (time.getTime() < today.getTime()) {
            return true;
          }
          
          // 2. 禁用已配置的日期
          if (this.disabledDates && this.disabledDates.length > 0) {
            const dateStr = this.formatDateForCompare(time);
            // 检查是否存在于禁用列表中（支持带时间和不带时间的格式）
            return this.disabledDates.some(disabledDate => {
              return this.isSameDay(dateStr, disabledDate);
            });
          }
          
          return false;
        }
      },
      // 新增表单中的日期选择器配置（只禁用今天之前的日期）
      formDatePickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        }
      },
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        robotId: null,
        statisticsDeptId: null,
        receiverNames: null,
        status: null,
      },
      // 表单参数
      form: {
        id: null,
        robotId: this.defaultRobotId,
        statisticsDeptId: null,
        statisticsDeptName: null,
        excludeApprovalGroupId: null,     // 分组ID
        excludeApprovalGroupName: null,   // 分组名称
        excludeApprovalTemplate: null,          // 模板ID
        excludeApprovalTemplateName: null,        // 模板名称
        receiverNames: null,
        status: 1,
        createTime: null,
        updateTime: null,
        statisticsDates: [],  // 新增时的日期数组
      },
      // 表单校验
      rules: {
        statisticsDeptId: [
          { required: true, message: "请选择被统计部门", trigger: "change" },
        ],
        receiverNames: [
          { required: true, message: "接收人名称不能为空", trigger: "blur" },
        ],
        statisticsDates: [
          { required: true, message: "请选择统计日期", trigger: "change" },
        ],
      },
      ordateList: [],
      typId: null,
    };
  },
  created() {
    this.getList();
    this.getTptGroupList();
  },
  methods: {
    /** 判断两个日期是否是同一天（支持多种格式） */
    isSameDay(date1, date2) {
      // 提取日期部分（YYYY-MM-DD）
      const extractDate = (date) => {
        if (!date) return '';
        const str = String(date);
        // 如果包含空格，取第一部分
        if (str.includes(' ')) {
          return str.split(' ')[0];
        }
        // 如果是 Date 对象
        if (date instanceof Date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
        return str;
      };
      
      return extractDate(date1) === extractDate(date2);
    },

    /** 格式化日期（去除时间部分） */
    formatDate(dateStr) {
      if (!dateStr) return '';
      if (dateStr.includes(' ')) {
        return dateStr.split(' ')[0];
      }
      return dateStr;
    },
    
    /** 格式化日期用于比较（YYYY-MM-DD） */
    formatDateForCompare(date) {
      if (date instanceof Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      return String(date);
    },
    
    /** 重置表单 */
    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    /** 查询配置列表 */
    getList() {
      this.loading = true;
      listClockInStatistics(this.queryParams).then((response) => {
        this.statisticsList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    /** 取消按钮 */
    cancel() {
      this.open = false;
      this.reset();
    },
    /** 表单重置 */
    reset() {
      this.form = {
        id: null,
        robotId: this.defaultRobotId,
        statisticsDeptId: null,
        statisticsDeptName: null,
        excludeApprovalGroupId: null,
        excludeApprovalGroupName: null,
        excludeApprovalTemplate: null,
        excludeApprovalTemplateName: null,
        receiverNames: null,
        status: 1,
        createTime: null,
        updateTime: null,
        statisticsDates: [],
      };
      this.templateOptions = [];
      this.isDetail = false;
      this.isEditMode = false;
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 多选框选中数据 */
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.isEditMode = false;
      this.open = true;
      this.title = "新增考勤统计配置";
      this.form.robotId = this.defaultRobotId;
      this.form.status = 1;
      this.form.statisticsDates = [];
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids[0];
      this.isDetail = false;
      this.isEditMode = true;
      getClockInStatistics(id).then((response) => {
        const data = response.data;
        this.form = data;
        this.typId = data.excludeApprovalTemplate
        // 回显分组和模板信息
        if (data.excludeApprovalGroupId) {
          this.handleGroupChange(data.excludeApprovalGroupId);
        }
        if (!this.form.status) {
          this.form.status = 1;
        }
        this.open = true;
        this.title = "修改考勤统计配置";
      });
    },
    /** 详情按钮操作 */
    handleDetail(row) {
      this.reset();
      const id = row.id;
      this.isDetail = true;
      this.isEditMode = true;
      getClockInStatistics(id).then((response) => {
        const data = response.data;
        this.form = data;
         this.typId = data.excludeApprovalTemplate
        if (data.excludeApprovalGroupId) {
          this.handleGroupChange(data.excludeApprovalGroupId);
        }
        this.open = true;
        this.title = "查看考勤统计配置详情";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // 新增时校验日期
          if (!this.isEditMode && (!this.form.statisticsDates || this.form.statisticsDates.length === 0)) {
            this.$message.warning('请选择至少一个统计日期');
            return;
          }

          const submitData = { ...this.form };
          
          if (this.form.id != null) {
            // 修改：不传日期
            delete submitData.statisticsDates;
            updateClockInStatistics(submitData).then((response) => {
              this.$message({
                type: "success",
                message: "修改成功",
              });
              this.open = false;
              this.getList();
            });
          } else {
            // 新增：直接传入日期
            if (submitData.statisticsDates && submitData.statisticsDates.length > 0) {
              submitData.statisticsDates = submitData.statisticsDates;
            }
            addClockInStatistics(submitData).then((response) => {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      const count = Array.isArray(ids) ? ids.length : 1;
      this.$confirm(
        `是否确认删除${count}条考勤统计配置？`,
        "警告",
        {
          type: "warning",
        }
      )
        .then(() => {
          if (Array.isArray(ids)) {
            const promises = ids.map((id) => delClockInStatistics({ id }));
            return Promise.all(promises);
          } else {
            return delClockInStatistics({ id: ids });
          }
        })
        .then(() => {
          this.getList();
          this.$message({
            message: "删除成功",
            type: "success",
          });
        })
        .catch(() => {});
    },
    /** 打开部门树选择 */
    openDeptTree() {
      if (this.isDetail) return;
      this.deptTreeVisible = true;
      this.selectDeptList = [];
    },
    /** 关闭部门树 */
    closeDeptTree(e) {
      this.deptTreeVisible = false;
      if (e === 2) {
        this.selectDeptList = [];
        this.form.statisticsDeptId = null;
        this.form.statisticsDeptName = null;
      }
    },
    /** 获取部门树选择的部门列表 */
    getDeptSelectList(list) {
      console.log("选择的部门:", list);
      if (list && list.length > 0) {
        const selectedDept = list[0];
        this.form.statisticsDeptId = selectedDept.deptId;
        this.form.statisticsDeptName = selectedDept.deptName;
        this.selectDeptList = list;
        this.$refs["form"].validateField("statisticsDeptId");
      }
      this.deptTreeVisible = false;
    },

    /** 获取分组列表 */
    getTptGroupList() {
      GetGlobalTptGroupoPage({
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      }).then((res) => {
        if (res.code === 200) {
          this.groupOptions = res.data || [];
        }
      });
    },
    /** 获取模板列表 */
    getTptList(groupId) {
      GetTptList({
        groupId: groupId,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      }).then((res) => {
        if (res.code === 200) {
          this.templateOptions = res.data || [];
          this.form.excludeApprovalTemplate = this.typId;
        }
      });
    },
    /** 分组变更事件 */
    handleGroupChange(val) {
      // 清空模板选择
      this.form.excludeApprovalTemplate = null;
      this.form.excludeApprovalTemplateName = null;
      this.templateOptions = [];
      
      // 查找分组名称
      const group = this.groupOptions.find(item => item.id === val);
      if (group) {
        this.form.excludeApprovalGroupName = group.name;
      }
      console.log('分组id:', val);
      // 加载模板列表
      if (val) {
        this.getTptList(val);
      }
    },

    // ========== 日期管理相关方法 ==========
    /** 打开日期管理弹窗 */
    handleManageDates(row) {
      this.currentConfigId = row.id;
      this.currentDeptName = row.statisticsDeptName;
      this.dateDialogVisible = true;
      this.newDates = [];
      this.disabledDates = []; // 清空禁用列表
      this.loadDateList();
    },

    /** 加载已配置的日期列表 */
    loadDateList() {
      clockInStatisticsDatelist({ statisticsConfigId: this.currentConfigId }).then((response) => {
        const rows = response.rows || response.data || [];
        this.ordateList = rows;
        // 提取日期字符串数组（保留原始格式）
        this.dateList = rows.map(item => item.date);
        // 【关键】将已配置的日期赋值给 disabledDates，用于禁用（保留原始格式）
        this.disabledDates = rows.map(item => item.date);
        // 清空新选择的日期
        this.newDates = [];
      });
    },

    /** 新增日期 */
    submitDates() {
      if (!this.newDates || this.newDates.length === 0) {
        this.$message.warning('请选择要新增的日期');
        return;
      }

      this.dateSubmitting = true;
      clockInStatisticsDateBatch({
        statisticsConfigId: this.currentConfigId,
        dates: this.newDates
      }).then(() => {
        this.$message.success(`成功添加 ${this.newDates.length} 个日期`);
        this.newDates = [];
        this.loadDateList(); // 重新加载，更新禁用列表
      }).finally(() => {
        this.dateSubmitting = false;
      });
    },

    /** 删除单个日期 */
    handleDeleteDate(date) {
      // 从 ordateList 中查找匹配的日期对象
      const targetItem = this.ordateList.find(item => {
        // 支持两种格式的比较：带时间或不带时间
        const itemDate = item.date.includes(' ') ? item.date.split(' ')[0] : item.date;
        const targetDate = date.includes(' ') ? date.split(' ')[0] : date;
        return itemDate === targetDate;
      });
      
      if (!targetItem) {
        this.$message.warning('未找到该日期记录');
        return;
      }

      this.$confirm(`确认删除日期 ${this.formatDate(date)}？`, '提示', {
        type: 'warning'
      }).then(() => {
        return clockInStatisticsDatedelete({ 
          id: targetItem.id 
        });
      }).then(() => {
        this.$message.success('日期删除成功');
        // 从 dateList 中移除该日期
        const index = this.dateList.findIndex(item => {
          const itemDate = item.includes(' ') ? item.split(' ')[0] : item;
          const targetDate = date.includes(' ') ? date.split(' ')[0] : date;
          return itemDate === targetDate;
        });
        if (index > -1) {
          this.dateList.splice(index, 1);
        }
        // 从 ordateList 中移除该记录
        const idx = this.ordateList.indexOf(targetItem);
        if (idx > -1) {
          this.ordateList.splice(idx, 1);
        }
        // 【关键】从 disabledDates 中移除该日期
        const disabledIndex = this.disabledDates.findIndex(item => {
          const itemDate = item.includes(' ') ? item.split(' ')[0] : item;
          const targetDate = date.includes(' ') ? date.split(' ')[0] : date;
          return itemDate === targetDate;
        });
        if (disabledIndex > -1) {
          this.disabledDates.splice(disabledIndex, 1);
        }
      }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.demo-drawer__footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  padding: 20px 0;
  margin: 0 20px;
}

::v-deep .el-drawer__body {
  padding-bottom: 80px;
}

::v-deep .el-input-group__append {
  cursor: pointer;
}

::v-deep .el-date-editor--daterange {
  width: 100%;
}

.el-tag {
  margin: 2px 4px;
}
</style>